var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.5C17.0005 10.6959 16.949 10.8885 16.8507 11.0593C16.7523 11.23 16.6104 11.3729 16.4386 11.4742L5.79636 17.8302C5.61694 17.9374 5.41144 17.996 5.20108 17.9998C4.99072 18.0036 4.78314 17.9525 4.59977 17.8518C4.41815 17.7527 4.26685 17.6081 4.16144 17.4329C4.05603 17.2578 4.0003 17.0584 4 16.8552V4.14478C4.0003 3.94163 4.05603 3.74222 4.16144 3.56707C4.26685 3.39191 4.41815 3.24733 4.59977 3.14819C4.78314 3.04748 4.99072 2.99639 5.20108 3.0002C5.41144 3.004 5.61694 3.06256 5.79636 3.16982L16.4386 9.52577C16.6104 9.62707 16.7523 9.77002 16.8507 9.94074C16.949 10.1115 17.0005 10.3041 17 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.fdd709e3477ac4e722fdd06d19a21725.svg";
export { ForwardRef as ReactComponent };